/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2025-02-10 16:56:56
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2025-02-12 09:34:38
 * @FilePath: /hippo-app-h5/hippo-app-h5/src/router/routerGuard.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { Router } from 'vue-router'
import { UserStore } from '@/store/modules/users'
import { bridge } from '@/utils/bridge'
import QT from '@/utils/QT'

export default (router: Router) => {
  router.beforeEach((to, _, next) => {
    const userStore = UserStore()
    userStore.setGoAppUrl('')
    if (to.meta.title) {
      document.title = String(to.meta.title)
    }

    if (!userStore.token) {
      userStore.setUserInfo()
    }
    // 增加qt全局属性
    try {
      if (to.path === '/dowmForBrand') {
        // console.log("userId" + userStore.userInfo?.userId)
        // console.log("ssoid" + userStore.userInfo?.ssoId)
        // console.log("beanId" + userStore.userInfo?.beanId)
        // 五品牌下载页面
        if (userStore) {
          QT.qt.setMetaInfo(userStore.userInfo?.userId || userStore.userInfo?.ssoId || userStore.userInfo?.beanId)
          QT.qt.appenGlobalproperty({
            nick_name: userStore.userInfo?.nickName || '',
            isCarOwner: userStore.userInfo.isCarOwner,
            nick: userStore.userInfo?.nick || '',
          })
        }
      }
      else if (userStore.userInfo && userStore.userInfo?.userId) {
        QT.qt.setMetaInfo(userStore.userInfo?.userId)
        QT.qt.appenGlobalproperty({
          nick_name: userStore.userInfo?.nickName || '',
          isCarOwner: userStore.userInfo.isCarOwner,
          nick: userStore.userInfo?.nick || '',
        })
      }
    } catch (error) {
      console.log(error)
    }
    if (to.meta.auth && !userStore.token) {
      if (bridge.isApp) {
        bridge.login()
      } else {
        // todo H5登录
      }
    }

    next()
  })
}
